const reportDB = require("../../../../../components/report/report-db");
const report = require("../../../../../components/report/report");
const page = require("../../../../../components/page/page");
const { generateReceivableAll } = require("../reportHub/reportHub-reportAll-template");
const { generateReceivableOneDocument } = require("../reportHub/reportHub-reportOne-template");
import { createChart } from "./chart/accountsReceivable-page-chart";

let cachedReportDateFilter = null;

export function getCachedReportDateFilter() {
  return cachedReportDateFilter;
}

export function fetchAll(detail, callback) {
  const phpFile = "server/php/sql/report.php";
  if (detail.filterBy && detail.filterBy.endDate) {
    cachedReportDateFilter = {
      startDate: detail.filterBy.startDate || detail.filterBy.endDate,
      endDate: detail.filterBy.endDate,
    };
  } else {
    cachedReportDateFilter = null;
  }
  detail.inf = { entity: "customer", report: "account-receivable-all" };
  if (detail.sort) {
    detail.inf.sort_by = detail.sort.by;
    detail.inf.sort_dir = detail.sort.dir;
  }

  if (detail.search) {
    detail.inf.searchReceivable = detail.search;
  }

  if (detail.filterBy) {
    detail.inf.startDate = detail.filterBy.startDate;
    detail.inf.endDate = detail.filterBy.endDate;
  }

  reportDB.select(detail, phpFile, (data) => {
    callback(data);
    createChart(data);
    detail.skipReportPage = true; // Skip the report page
    report.show(detail, () => {
      const pageTarget = document.getElementById("accountsReceivable-page-right");

      const existingContent = pageTarget.querySelector(".accountsReceivable-dataCont");
      if (existingContent) {
        existingContent.remove();
      }

      const body = generateReceivableAll(data);
      pageTarget.insertAdjacentHTML("beforeend", body);
    });
  });
}

export function fetchOne(detail, callback) {
  const phpFile = "server/php/sql/report.php";
  detail.inf = {
    entity: "customer",
    report: "account-receivable-all-one",
    dbid: detail.dbid,
  };
  if (cachedReportDateFilter) {
    detail.inf.startDate = cachedReportDateFilter.startDate;
    detail.inf.endDate = cachedReportDateFilter.endDate;
  }

  reportDB.select(detail, phpFile, (data) => {
    callback(data);
  });
}

export function fetchUnpaidInvoices(detail, callback) {
  const phpFile = "server/php/sql/report.php";
  detail.inf = {
    entity: "customer",
    report: "account-receivable-one",
    id: detail.dbid,
  };
  if (cachedReportDateFilter) {
    detail.inf.startDate = cachedReportDateFilter.startDate;
    detail.inf.endDate = cachedReportDateFilter.endDate;
  }

  reportDB.select(detail, phpFile, (data) => {
    callback(data);
  });
}

export function buildReceivableAllPrintHtml(data) {
  return generateReceivableAll(data);
}

function appendReportInfDates(inf, filters) {
  if (filters.startDate) inf.startDate = filters.startDate;
  if (filters.endDate) inf.endDate = filters.endDate;
  if (filters.useYear) inf.filterByYear = "1";
}

export function fetchReceivableOneBundleForHub(filters, callback) {
  const phpFile = "server/php/sql/report.php";

  const detailTop = {
    inf: { entity: "customer", report: "account-receivable-all-one", dbid: filters.dbid },
  };
  appendReportInfDates(detailTop.inf, filters);

  reportDB.select(detailTop, phpFile, (topData) => {
    if (!topData || !topData.length) {
      callback(null, null);
      return;
    }
    const detailLines = {
      inf: { entity: "customer", report: "account-receivable-one", id: filters.dbid },
    };
    appendReportInfDates(detailLines.inf, filters);

    reportDB.select(detailLines, phpFile, (tableData) => {
      callback(topData, tableData || []);
    });
  });
}

export function buildReceivableOnePrintHtml(topRows, detailRows) {
  return generateReceivableOneDocument(topRows, detailRows);
}
